import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { compose, branch, renderComponent } from 'recompose'
import cx from 'classnames'
import { Div, H3, Button } from '@drifthq/tide-core'

import { isExtensionInstalled } from 'utils/extension'
import config from 'config'

import laptopWithFaceSrc from './drift-laptop-with-face.png'
import gradientArrowLeft from './gradient-arrow-left.svg'
import boltTrioTeal from './bolt-trio-teal.svg'
import boltTrioPink from './bolt-trio-pink.svg'

import './style.css'

class VideoInstallStep extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      showInstallOverlay: false,
    }
  }

  launchWebStore = () => {
    const height = window.innerHeight + window.innerHeight * 0.12
    const width = window.innerWidth / 2

    const popup = window.open(
      config.HYFY_EXTENSION_URL,
      'Drift Video Extension',
      `location=1,directories=1,toolbar=1,titlebar=1,resizeable=1,scrollbars=1,status=1,left=${
        window.screenX
      },top=${window.screenY},width=${width},height=${height}`
    )

    const popupTick = setInterval(async () => {
      if (popup.closed) {
        const installed = await isExtensionInstalled()
        if (installed) {
          clearInterval(popupTick)
          this.props.actions.push('/video/success')
        }
      }
    }, 500)
  }

  onInstallClick = () => {
    this.setState({ showInstallOverlay: true })
    this.launchWebStore()
  }

  onRetryInstallClick = () => {
    this.launchWebStore()
  }

  onDismissInstallClick = () => {
    this.setState({ showInstallOverlay: false })
  }

  render() {
    const { name } = this.props
    const { showInstallOverlay } = this.state

    return (
      <div className="video-install-container">
        <div className="drift-getting-started">
          <div className="drift-install-content">
            <img className="drift-bolt-trio-left" src={boltTrioPink} alt="bolts-pink" />
            <Div className="drift-getting-started-microcopy">Welcome{name && `, ${name}`}!</Div>
            <H3 className="drift-getting-started-title">
              Add Drift Video to Chrome to record your first video!
            </H3>
            <Button className="drift-install-CTA" onClick={this.onInstallClick}>
              Visit Chrome store
            </Button>
          </div>
          <img className="drift-install-image" src={laptopWithFaceSrc} alt="laptop-with-face" />
        </div>
        <div
          className={cx('drift-install-overlay-container', { 'show-overlay': showInstallOverlay })}
          id="drift-install-overlay-container"
        >
          <div className="drift-install-overlay-left">
            <span className="drift-install-retry-copy">Trouble installing? Try this! <span role="img" aria-label="pointing right">👉</span></span>
            <div className="drift-install-retry">
              <Button className="drift-install-CTA" onClick={this.onRetryInstallClick}>
                Retry installation
              </Button>
              <Div className="drift-install-dismiss" onClick={this.onDismissInstallClick}>
                Not now
              </Div>
            </div>
          </div>
          <div className="drift-install-overlay-right">
            <img className="drift-install-arrow" src={gradientArrowLeft} alt="arrow" />
            <div className="drift-getting-started-title">Click to add Drift Video</div>
            <img className="drift-bolt-trio-right" src={boltTrioTeal} alt="bolts-teal" />
          </div>
        </div>
      </div>
    )
  }
}

const ChromeInstallStep = ({ name }) => (
  <div className="video-install-container">
    <div className="drift-getting-started">
      <div className="drift-install-content">
        <img className="drift-bolt-trio-left" src={boltTrioPink} alt="bolts-pink" />
        <Div className="drift-getting-started-microcopy">Welcome{name && `, ${name}`}!</Div>
        <H3 className="drift-getting-started-title">
          Sorry, Drift Video is only available on Google Chrome.
        </H3>
        <Button className="drift-install-CTA" href="https://www.google.com/chrome/b/" target="_blank">
          Get Chrome
        </Button>
      </div>
    </div>
  </div>
)

const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime)

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    push,
  }, dispatch)
})

export default compose(
  connect(null, mapDispatchToProps),
  branch(props => !isChrome, renderComponent(ChromeInstallStep))
)(VideoInstallStep)



// WEBPACK FOOTER //
// ./src/layouts/VideoInstallStep/index.js